export const FETCH_BONUS_START = 'FETCH_BONUS_START';
export const FETCH_BONUS_SUCCESS = 'FETCH_BONUS_SUCCESS';
export const FETCH_BONUS_FAILURE = 'FETCH_BONUS_FAILURE';

